<template>

    <div v-cloak class="container-fluid">

        <div>

            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>
                        {{cmsContentBlocks['preCertTest.Header']}}
                    </h5>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row d-none d-lg-block">
                <div class="col">
                    <hr>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">

                <div class="col-12 col-lg-6">

                    <div v-if="sendToThisMailbox" class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            To: {{sendToThisMailbox}}
                        </div>
                    </div>

                    <div v-else>
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                <label for="to-mailbox">{{cmsContentBlocks['preCertTest.ToLabel']}}</label>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component id="to-mailbox" key="drDropDown" v-error-message="{ errorModel: 'errorModel.toMailboxId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.toMailboxId" :placeholder="cmsContentBlocks['preCertTest.ToDropDownPlaceHolder']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.toMailboxId | firstError }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="showPhysicianDropDown">
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                Physician
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="physDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toPhysicianId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="reassignPhysicianDropDown" v-model="messageModel.toPhysicianId" :placeholder="cmsContentBlocks['preCertTest.ToDropDownPlaceHolder']">
                                </select2-component>
                            </div>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="name-of-test">{{cmsContentBlocks['preCertTest.NameOfTestLabel']}}</label>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col">
                            <input id="name-of-test" type="text" :placeholder="cmsContentBlocks['preCertTest.NameOfTestInputPlaceHolder']" v-model="messageModel.nameOfTest" v-error-message="{ errorModel: 'errorModel.nameOfTest' }" class="form-control" maxlength="150" />
                            <span class="invalid-feedback is-invalid">{{ errorModel.nameOfTest | firstError }}</span>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="date-scheduled">{{cmsContentBlocks['preCertTest.DateScheduledLabel']}}</label>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <div class="input-group">
                                <date-picker-component id="date-scheduled"
                                                       ref="dateScheduledPicker"
                                                       :typeable="true"
                                                       v-error-message="{ errorModel: 'errorModel.dateScheduled' }"
                                                       class="form-control vdp-datepickerinput"
                                                       placeholder="MM / DD / YYYY"
                                                       format="MM/dd/yyyy"
                                                       v-model="messageModel.dateScheduled">
                                </date-picker-component>
                                <div class="input-group-append">
                                    <div @click="$refs.dateScheduledPicker.showCalendar()" class="input-group-text bg-white rounded-right">
                                        <i class="far fa-calendar-alt text-primary"></i>
                                    </div>
                                </div>
                                <span class="invalid-feedback is-invalid">{{ errorModel.dateScheduled | firstError }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="name-of-insurance">{{cmsContentBlocks['preCertTest.NameOfInsuranceLabel']}}</label>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <input id="name-of-insurance" type="text" :placeholder="cmsContentBlocks['preCertNutritionalSupplement.NameOfInsuranceTextBoxPlaceHolder']" v-model="messageModel.nameOfInsuranceCompany" v-error-message="{ errorModel: 'errorModel.nameOfInsuranceCompany' }" class="form-control" maxlength="150" />
                            <span class="invalid-feedback is-invalid">{{ errorModel.nameOfInsuranceCompany | firstError }}</span>
                        </div>
                    </div>

                </div>

                <div class="col-12 col-lg-6">

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="policy-number">{{cmsContentBlocks['preCertTest.PolicyNumberLabel']}}</label>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <input id="policy-number" type="text" :placeholder="cmsContentBlocks['preCertTest.PolicyNumberTextBoxPlaceHolder']" v-model="messageModel.policyNumber" v-error-message="{ errorModel: 'errorModel.policyNumber' }" class="form-control" maxlength="100" />
                            <span class="invalid-feedback is-invalid">{{ errorModel.policyNumber | firstError }}</span>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="phone-number">{{cmsContentBlocks['preCertTest.PhoneNumberLabel']}}</label>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <input id="phone-number" type="text" v-mask="usaPhoneNumberFormat" v-error-message="{ errorModel: 'errorModel.phoneNumber' }" class="form-control" maxlength="25" v-model="messageModel.phoneNumber" :placeholder="cmsContentBlocks['preCertTest.PhoneNumberTextBoxPlaceHolder']" />
                            <span class="invalid-feedback is-invalid">{{ errorModel.phoneNumber | firstError }}</span>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black">
                        <div class="col" v-once>
                            {{cmsContentBlocks['preCertTest.IsTestAtMsk']}}
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <div class="custom-control custom-radio mt-2">
                                <input type="radio" name="isAtMsk" id="TestAtMsk" v-model="messageModel.testIsAtMsk" class="custom-control-input" :value="true" v-error-message="{ errorModel: 'errorModel.testIsAtMsk' }">
                                <label for="TestAtMsk" class="custom-control-label">{{cmsContentBlocks['preCertTest.IsTestAtMskTrue']}}</label>
                            </div>

                            <div class="custom-control custom-radio mt-2">
                                <input type="radio" name="isAtMsk" id="TestNotAtMsk" v-model="messageModel.testIsAtMsk" class="custom-control-input" :value="false" v-error-message="{ errorModel: 'errorModel.testIsAtMsk' }">
                                <label for="TestNotAtMsk" class="custom-control-label">{{cmsContentBlocks['preCertTest.IsTestAtMskFalse']}}</label>
                            </div>

                            <div v-if="errorModel.testIsAtMsk" class="row">
                                <div class="col">
                                    <span class="d-block invalid-feedback is-invalid">{{errorModel.testIsAtMsk | firstError}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="messageModel.testIsAtMsk == false">

                        <div class="row text-portal-soft-black mb-1 mt-3">
                            <div class="col" v-once>
                                <h6>{{cmsContentBlocks['preCertTest.FacilityHeader']}}</h6>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col" v-once>
                                <label for="name-of-facility">{{cmsContentBlocks['preCertTest.NameOfFacilityLabel']}}</label>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                <input id="name-of-facility" type="text" :placeholder="cmsContentBlocks['preCertTest.NameOfFacilityTextBoxPlaceHolder']" v-model="messageModel.nameOfFacility" v-error-message="{ errorModel: 'errorModel.nameOfFacility' }" class="form-control" maxlength="200" />
                                <span class="invalid-feedback is-invalid">{{ errorModel.nameOfFacility | firstError }}</span>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col" v-once>
                                <label for="facility-address">{{cmsContentBlocks['preCertTest.FacilityAddressLabel']}}</label>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                <input id="facility-address" type="text" :placeholder="cmsContentBlocks['preCertTest.FacilityAddressTextBoxPlaceHolder']" v-model="messageModel.facilityAddress" v-error-message="{ errorModel: 'errorModel.facilityAddress' }" class="form-control" maxlength="200" />
                                <span class="invalid-feedback is-invalid">{{ errorModel.facilityAddress | firstError }}</span>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col" v-once>
                                <label for="facility-phone-number">{{cmsContentBlocks['preCertTest.FacilityPhoneNumber']}}</label>
                            </div>
                        </div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                <input id="facility-phone-number" type="text" v-mask="usaPhoneNumberFormat" v-error-message="{ errorModel: 'errorModel.facilityPhoneNumber' }" class="form-control" maxlength="25" v-model="messageModel.facilityPhoneNumber" :placeholder="cmsContentBlocks['preCertTest.FacilityPhoneNumberTextBoxPlaceHolder']" />
                                <span class="invalid-feedback is-invalid">{{ errorModel.facilityPhoneNumber | firstError }}</span>
                            </div>
                        </div>


                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import { mask } from 'vue-the-mask'
    import { usaPhoneNumberFormat } from '@SharedServices/formatting.service';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: 'preCertTest',
        props: {
            physicianDropDown: { type: Array },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            //if set this is for ITC, DTC, etc. The "To Mailbox Id" will not be shown
            sendToThisMailbox: { type: String },
            //list of Reassign Physicians
            reassignPhysicianDropDown: { type: Array },
            //show or hide Reassign Physicians drop down
            showPhysicianDropDown: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'date-picker-component': Datepicker,
        },
        directives: {
            mask
        },
        data: function () {
            return {
                usaPhoneNumberFormat,

                messageModel: {
                    toMailboxId: null, //mailbox id
                    toPhysicianId: "", //physician id
                    nameOfTest: null,
                    phoneNumber: null,
                    dateScheduled: null,
                    policyNumber: null,
                    nameOfInsuranceCompany: null,
                    testIsAtMsk: null, //true - false
                    nameOfFacility: null,
                    facilityAddress: null,
                    facilityPhoneNumber: null
                }
            }
        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },
        }
    };
</script>

